export default __webpack_public_path__ + "1d539ccea57738d0ee5fa425279d5802.svg";